import GeomAxis from './GeomAxis.js'
import animation from './animation.js'

/* Geom : keep and modify position and length of 2D object
 * Only objects obj.x and obj.y are modified.
 * See GeomAxis class for more details.
*/
export default class Geom {
  constructor(obj, ext={}, lim={}) {
    this.x = new GeomAxis(obj.x, ext.x, lim.x)
    this.y = new GeomAxis(obj.y, ext.y, lim.y)
  }
  check(res=true) {
    return this.y.check(this.x.check(res))
  }
  move(dpos={x: 0, y: 0}) {
    return {
      x: this.x.move(dpos.x),
      y: this.y.move(dpos.y)
    }
  }
  moveTo(pos={x: null, y: null}) {
    return {
      x: this.x.moveTo(pos.x),
      y: this.y.moveTo(pos.y)
    }
  }
  resize(dlen={x: 0, y: 0}, dir={x: 1, y: 1}) {
    return {
      x: this.x.resize(dlen.x, dir.x),
      y: this.y.resize(dlen.y, dir.y)
    }
  }
  resizeTo(len={x: null, y: null}, dir={x: 1, y: 1}) {
    return {
      x: this.x.resizeTo(len.x, dir.x),
      y: this.y.resizeTo(len.y, dir.y)
    }
  }
  increase(delt={x: 1, y: 1}) {
    let resx = this.x.increase(delt.x)
    let resy = this.y.increase(delt.y)
    return resx || resy
  }
  maximize(delt={x: 1, y: 1}) {
    animation(() => this.increase({x: delt.x, y: delt.y}))
  }
  minimize(delt={x: 1, y: 1}) {
    animation(() => this.increase({x:-delt.x, y:-delt.y}))
  }
  getPosDelt() {
    return {x: this.x.getPosDelt(), y: this.y.getPosDelt()}
  }
  getLenDelt() {
    return {x: this.x.getLenDelt(), y: this.y.getLenDelt()}
  }
}



// WEBPACK FOOTER //
// ./src/float/vue/utils/Geom.js